import request from "_private/utils/request";
// 车辆数据导出

// 列表分页查询接口
export function FetchFindByPage(data) {
  return request({
    headers: { type: "json" },
    url: "/report/ExportDataTask/findByPage",
    method: "post",
    data
  });
}

// 获取任务id
export function getTaskNo() {
  return request({
    url: "/report/ExportDataTask/getTaskNo",
    method: "post"
  });
}

// 获取车辆树
export function getExportDataVehicleInfoTree() {
  return request({
    url: "/report/ExportDataTask/getExportDataVehicleInfoTree",
    method: "post"
  });
}

// 保存提交
export function saveExportDataTask(data) {
  return request({
    headers: { type: "json" },
    url: "/report/ExportDataTask/saveExportDataTask",
    method: "post",
    data
  });
}
// 根据部门获取车辆
export function getVehicleListByCompanyId(data) {
  return request({
    url: "/base/vehicle/getVehicleListByCompanyId",
    method: "post",
    data
  });
}
